import Text from '@passkeys/ui/text';

function HeaderTitle({ children }) {
  if (typeof children === 'string') {
    return <Text as="h1">{children}</Text>;
  }

  return children;
}

export default HeaderTitle;
